export type ErrorDispute = {
  userId: string;
  textDiffId: string;
  index: number;
};
